import { render } from "./NewTest.vue?vue&type=template&id=52e0f270&scoped=true"
import script from "./NewTest.vue?vue&type=script&lang=js"
export * from "./NewTest.vue?vue&type=script&lang=js"

import "./NewTest.vue?vue&type=style&index=0&id=52e0f270&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e0f270"]])

export default __exports__